import {Component, inject} from '@angular/core';
import {ModalRef} from '@shared/components/modal/modal.ref';
import {MODAL_CONFIG} from '@shared/components/modal/modal.token';
import {ModalConfig} from '@shared/components/modal/modal.config';

@Component({
  selector: 'app-document-delete-dialog',
  templateUrl: './document-delete-dialog.html',
})
export class DocumentDeleteDialog {
  private readonly modalRef = inject(ModalRef<boolean>);
  private readonly config = inject<ModalConfig | null>(MODAL_CONFIG, {optional: true});

  fileName(): string {
    return this.config?.data?.fileName || 'ce document';
  }

  confirm(): void {
    this.modalRef.close(true);
  }

  cancel(): void {
    this.modalRef.close(false);
  }
}
